module.exports = __webpack_public_path__ + "static/media/grad.5fdaeaf6.png";